import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconInTransit = ({ color = 'var(--color-accent-4)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group 550">
                <g id="Group 378">
                    <g id="icon">
                        <circle id="Ellipse 36" opacity="0.2" cx="18.5" cy="18.5" r="18.5" fill={color} />
                    </g>
                </g>
                <path id="&#239;&#131;&#145;" d="M26.625 21.25H26.25V18.7188C26.25 18.4375 26.1094 18.1328 25.8984 17.9219L23.5781 15.6016C23.3672 15.3906 23.0625 15.25 22.7812 15.25H21.75V14.125C21.75 13.5156 21.2344 13 20.625 13H13.125C12.4922 13 12 13.5156 12 14.125V21.625C12 22.2578 12.4922 22.75 13.125 22.75H13.5C13.5 23.9922 14.5078 25 15.75 25C16.9922 25 18 23.9922 18 22.75H21C21 23.9922 22.0078 25 23.25 25C24.4922 25 25.5 23.9922 25.5 22.75H26.625C26.8125 22.75 27 22.5859 27 22.375V21.625C27 21.4375 26.8125 21.25 26.625 21.25ZM15.75 23.875C15.1172 23.875 14.625 23.3828 14.625 22.75C14.625 22.1406 15.1172 21.625 15.75 21.625C16.3594 21.625 16.875 22.1406 16.875 22.75C16.875 23.3828 16.3594 23.875 15.75 23.875ZM23.25 23.875C22.6172 23.875 22.125 23.3828 22.125 22.75C22.125 22.1406 22.6172 21.625 23.25 21.625C23.8594 21.625 24.375 22.1406 24.375 22.75C24.375 23.3828 23.8594 23.875 23.25 23.875ZM25.125 19H21.75V16.375H22.7812L25.125 18.7188V19Z" fill={color} />
            </g>
        </svg>

    </div>
);

export default IconInTransit;
